export const imagesDisplay = (images) => {
  switch (images.length) {
    case 0:
      return [];
    case 1:
      return [
        {
          images: [images[0]],
          height: { _: 200, m: 404 },
        },
      ];
    case 2:
      return [
        {
          images: [images[0], images[1]],
          height: { _: 185, m: 300 },
        },
      ];
    case 3:
      return [
        {
          images: [images[0]],
          height: { _: 185, m: 300 },
        },
        {
          images: [images[1], images[2]],
          height: { _: 185, m: 300 },
        },
      ];
    case 4:
      return [
        {
          images: [images[0]],
          height: { _: 185, m: 300 },
        },
        {
          images: [images[1], images[2], images[3]],
          height: { _: 120, m: 200 },
        },
      ];
    case 5:
      return [
        {
          images: [images[0], images[1]],
          height: { _: 185, m: 300 },
        },
        {
          images: [images[2], images[3], images[4]],
          height: { _: 120, m: 200 },
        },
      ];
    case 6:
    default:
      return [
        {
          images: [images[0], images[1], images[2]],
          height: { _: 120, m: 200 },
        },
        {
          images: [images[3], images[4], images[5]],
          height: { _: 120, m: 200 },
        },
      ];
  }
};
